// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.UpdateLandlordPaymentMethodWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod } from '@zg-rentals/ts-rent-payment-client';

import type {
  UpdatePaymentMethodWebApiRequestDto,
  UpdatePaymentMethodWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Args {
  postData: UpdatePaymentMethodWebApiRequestDto;
}

export type UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Options = UseMutationOptions<
  UpdatePaymentMethodWebApiResponseDto,
  unknown,
  UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Args
>;

/**
 * create or update landlord payment method
 */
export const useUpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod = ({
  httpClient,
  ...options
}: Omit<UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Args) =>
      UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod(args.postData, httpClient),
  });
};
